import { render, staticRenderFns } from "./cocktail-small-1.vue?vue&type=template&id=1500fcd0"
import script from "./cocktail-small-1.vue?vue&type=script&lang=js"
export * from "./cocktail-small-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports